import { createContext, useContext, useEffect, useState } from "react";
import {
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions"; // ✅ Import Firebase Functions
import { app } from "../../firebase";

// ✅ Création du contexte
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

// ✅ Fournisseur du contexte
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const auth = getAuth(app);
  const functions = getFunctions(app);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const email = firebaseUser.email;

        try {
          // ✅ Appel de la Cloud Function pour valider l'email
          const validateEmail = httpsCallable(functions, "validateAdminEmail");
          const response = await validateEmail({ email });

          console.log("📨 validateAdminEmail response:", response.data);

          const isAllowed = response.data.isAllowed;

          if (isAllowed) {
            setUser(firebaseUser);
            setIsAdmin(true);
            console.log("✅ Utilisateur autorisé :", email);
          } else {
            await signOut(auth);
            setUser(null);
            setIsAdmin(false);
            console.warn("⛔️ Utilisateur non autorisé :", email);
          }
        } catch (error) {
          console.error("❌ Erreur fonction validateAdminEmail :", error);
          setUser(null);
          setIsAdmin(false);
        }
      } else {
        setUser(null);
        setIsAdmin(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      console.log("✅ Connexion réussie :", result.user?.email);
    } catch (error) {
      console.error("❌ Erreur de connexion :", error);
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      console.log("🚪 Déconnecté.");
    } catch (error) {
      console.error("❌ Erreur de déconnexion :", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
